<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">
      
      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadLease" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onCarparkFilterChange" />

      <AppFilterDateRange
        ref="dateRangeFilter"
        v-on:filter-data-change="onFilterDateChange" />

      <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
        Export CSV
      </button>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_parkerAccount',
    text: 'Full Name',
  },
  {
    key: '_parkerMobile',
    text: 'Mobile No.',
  },
  {
    key: '_customerNationalID',
    text: 'NRIC / Passport No.',
  },
  {
    key: '_parkerEmail',
    text: 'Email',
  },
  {
    key: '_carparkCode',
    text: 'Car Park Code',
  },
  {
    key: '_carparkName',
    text: 'Car Park Name',
  },
  {
    key: 'parkingLicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
    form_hide: true, 
  },
  {
    key: '_paymentPlan',
    text: 'Payment Plan',
  },
  {
    key: '_companyName',
    text: 'Company Name',
  },
  {
    key: '_companyAddress',
    text: 'Company Address',
  },
  {
    key: 'status',
    text: 'Subscription Status',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['stopBillDate']) {
        return 'Stop Bill';
      }
      return dataItem['status'];
    },
  },
  {
    key: 'createDate',
    text: 'Date Apply',
    table_custom: helper.tableCustomDatetime,
  },
  {
    key: '_licenseCreateDate',
    text: 'Date Approve',
    table_custom: helper.tableCustomDatetime,
  },
  {
    key: '_parkerVehicle',
    text: 'Vehicle Registration No.',
  },
  {
    key: '_passcard',
    text: 'Passcard',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_passcard'];
      return (dataItem || {}).sku;
    },
  },
  {
    key: '_passcardStatus',
    text: 'Passcard Status',
  },
  {
    key: '_parkaideEnable',
    text: 'ParkAide Enabled',
  },
  {
    key: '_parkaideActiveDate',
    text: 'Date ParkAide Active',
  },
  {
    key: '_productName',
    text: 'Product Name',
  },
  {
    key: 'commencementDate',
    text: 'Commencement Date',
    table_custom: helper.tableCustomDate,
  },
  {
    key: '_stopbillDate',
    text: 'Stop Bill Date',
  },
  {
    key: '_terminateEffectiveDate',
    text: 'Date Terminate Effective',
  },
  {
    key: '_terminateCompleteDate',
    text: 'Date Terminate Complete',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageReportCompany",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Report' },
        { name: 'Company Customer Status' },
      ],

      PARAM,
      PARAM_MAP,

      isInitialSetCustomer: true,

      pagePasstype: null,
      pageCarpark: null,
      pageCarparkSeasonSetting: null,
      pageCarparkAddress: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageLease: null,
      pageSeason: null,
      pageSeasonFees: {},
      pageParker: null,
      pageCustomerAddress: {},

      showExportCSV: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
    this.loadPasscardType();
  },
  methods: {
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/licenses/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;

          if(response.data && response.data.length > 0) {
            this.pageLicense = response.data;
            this.loadPasscard();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No license data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscard() {
      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/passcard/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID);
            k['option'] = passtype ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLease() {
      let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
      let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);

      this.$refs['pageTable'].setTableData(this.pageLease = null);

      let feedbackItem = 'lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = this.getUrl();
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/leases/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage('');
            let temp = {};
            response.data.forEach(lease => {
              if(temp[lease['leaseNum']]) {
                if(temp[lease['leaseNum']].createDate < lease.createDate) {
                  if(!lease.passcardID) {
                    // TODO kw1 set complete passcard return lease passcard to null
                    if(lease.type === 'PasscardReturn') {
                    } else {
                      lease.passcardID = temp[lease['leaseNum']].passcardID;
                    }
                  }
                  temp[lease['leaseNum']] = lease;
                }
              } else {
                temp[lease['leaseNum']] = lease;
              }

              lease['_license'] = this.pageLicense.find(j => helper.compareID(j.id, lease['licenseID'])) || {};
              lease['_customer'] = this.pageCustomer.find(j => j.id === lease['_license']['customerID']) || {};
            })
            let temp2 = [];
            for(let temp1 in temp) {
              temp2.push(temp[temp1]);
            }
            this.pageLease = temp2;
            // this.pageLease = response.data;
            this.setLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No lease data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    setLease() {
      this.$refs['pageTable'].setTableData(null);

      // if(!this.$refs['licenseFilter'].filterData || this.$refs['licenseFilter'].filterData.length === 0) {
      //   return;
      // }

      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      if(!this.pageCarparkSeasonSetting) {
        this.loadCarparkSeasonSetting();
        return;
      }

      // if(!this.pageCarparkAddress) {
      //   this.loadCarparkAddress();
      //   return;
      // }

      let temp = this.pageLease;
      for(let leaseData of temp) {
        if(leaseData['seasonID'] && this.pageSeasonFees[leaseData['seasonID']] === undefined) {
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
        if(leaseData['_customer'] && this.pageCustomerAddress[leaseData['_customer'].id] === undefined) {
          this.loadCustomerAddress(leaseData['_customer'].id, leaseData['_customer'].address1);
          return true;
        }
      };

      let tempList = {};
      temp.forEach(k => {
        k['_license'] = this.pageLicense.find(j => helper.compareID(j.id, k['licenseID'])) || {};
        k['_licenseStatus'] = k['_license']['status'];
        k['_licenseNum'] = k['_license']['licenseOperatorNum'];
        k['_carparkNum'] = k['_license']['carparkID'];
        k['_licenseCreateDate'] = k['_license']['createDate'];
        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']) || {};
        k['_customerType'] = k['_customer'].isCompany ? 'Company' : 'Personal';
        k['_companyName'] = k['_customer'].name;
        
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']) || {};
        k['_carparkCode'] = k['_carpark'].id;
        k['_carparkName'] = k['_carpark'].name;

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']) || {};
        k['_productName'] = (k['_product'] || {}).name;
        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']) || {};
        k['_parkerInformation'] = helper.plFormParker(k['_parker']);
        k['_parkerAccount'] = k['_parker'].name;
        k['_parkerMobile'] = k['_parker'].mobile;
        k['_customerNationalID'] = k['_customer'].nationalID;
        k['_parkerEmail'] = k['_parker'].email;
        k['_parkerVehicle'] = k['_parker'].car1;

        if(k['passcardID']) {
          k['_passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, k['passcardID'])) || {};
          k['_passcardStatus'] = 'Passcard Issued';
        } else {
          if(k['status'] === 'Terminated') {
            k['_passcardStatus'] = 'Returned Passcard';
          } else if(k['status'] === 'Active' ||
            k['status'] === 'Stop Bill' || 
            k['status'] === 'Pending Termination' || 
            k['status'].includes('Terminated w ')) {
            // TODO kw1 or any state after application/addon active
            k['_passcardStatus'] = 'Pending Passcard Issuence';
          }
        }

        switch(parseInt(k['paymentPlan'])) {
          case 1:
            k['_paymentPlan'] = 'Monthly';
            k['_parkingFee'] = helper.formatMoney((this.pageSeasonFees[k['seasonID']] || {})['monthly']) + ' / month';
            break;
          case 2:
            k['_paymentPlan'] = 'Quarterly';
            k['_parkingFee'] = helper.formatMoney((this.pageSeasonFees[k['seasonID']] || {})['quarterly'] * 3) + ' / quarter';
            break;
          case 3:
            k['_paymentPlan'] = 'Half-yearly';
            k['_parkingFee'] = helper.formatMoney((this.pageSeasonFees[k['seasonID']] || {})['halfYearly'] * 6) + ' / half-year';
            break;
          case 4:
            k['_paymentPlan'] = 'Annually';
            k['_parkingFee'] = helper.formatMoney((this.pageSeasonFees[k['seasonID']] || {})['annually'] * 12) + ' / annual';
            break;
        }

        k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        k['_zoneName'] = (k['_zone'] || {}).name;

        if(this.pageCarparkSeasonSetting.ParkaideOnly) {
          k['_parkaideEnable'] = 'Yes';
        } else {
          k['_parkaideEnable'] = 'No';
        }

        let companyAddress = this.pageCustomerAddress[k['_customer'].id];
        if(companyAddress) {
          k['_companyAddress'] = companyAddress.companyAddress1 || '';
          k['_companyAddress'] += companyAddress.companyAddress1 ? '<br>' : '';
          k['_companyAddress'] += companyAddress.companyAddress2 || '';
          k['_companyAddress'] += companyAddress.companyAddress2 ? '<br>' : '';
          k['_companyAddress'] += companyAddress.companyAddress3 || '';
          k['_companyAddress'] += companyAddress.companyAddress3 ? '<br>' : '';
          k['_companyAddress'] += companyAddress.companyAddressPostalCode || '';
          k['_companyAddress'] += companyAddress.companyAddressPostalCode ? ' ' : '';
          k['_companyAddress'] += companyAddress.companyAddressCity || '';
          k['_companyAddress'] += companyAddress.companyAddressCity ? ', ' : '';
          k['_companyAddress'] += companyAddress.companyAddressState || '';
          // k['_companyAddress'] += companyAddress.companyAddressState ? ', ' : '';
          // k['_companyAddress'] += companyAddress.companyAddressCountry || '';
        }
      });

      temp = temp.filter(k => k['_customer'] && k['_customer'].isCompany);
      
      // let filterCustomer = this.$refs['customerFilter'].filterValue;
      // if(filterCustomer) {
      //   temp = temp.filter(k => k['_customer'] && helper.compareID(k['_customer']['id'], filterCustomer));
      // }

      this.$refs['pageTable'].setTableData(temp);
      this.showExportCSV = true;
    },
    loadSeason() {
      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.setLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.pageSeasonFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            if(this.pageSeasonFees[seasonID] = response.data[0]) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.setLease();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active product fees data available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product fees data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarparkSeasonSetting() {
      let feedbackItem = 'car park setting data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/seasonSetting/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageCarparkSeasonSetting = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.setLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarparkAddress() {
      let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue));
      if(!carpark || !carpark.addressData1) {
        this.pageCarparkAddress = {};
        this.setLease();
        return;
      }

      let feedbackItem = 'car park address data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + carpark.addressData1,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarparkAddress = helper.parseAddress(response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.setLease();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          // TODO kw1 load too much data?
          helper.SERVER_URL + '/api2/subscriber/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.setLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCustomerAddress(customerID, address) {
      if(!address) {
        this.pageCustomerAddress[customerID] = {};
        this.setLease();
        return;
      }
      
      this.pageCustomerAddress[customerID] = null;

      let feedbackItem = 'customer address data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/address/' + address,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCustomerAddress[customerID] = helper.parseAddress(response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.setLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    getUrl(carparkID) {
      let url = helper.SERVER_URL + '/api2';
      if(carparkID) {
        url += '/licenses/' + carparkID;
      }
      url += '/leases/';

      return url;
    },

    onCarparkFilterChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.pageSeason = null;
      this.pageParker = null;
      this.pageCarparkSeasonSetting = null;
      this.pageCarparkAddress = null;
      this.loadLicense();
    },
    onFilterDateChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.pageSeason = null;
      this.pageParker = null;
      this.pageCarparkSeasonSetting = null;
      this.pageCarparkAddress = null;
      this.loadLicense();
    },

    onAddButtonClick() {
    },
    onTableDataClick(tableData, tableDataIndex) {
    },

    onCSVButtonClick() {
      let startDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateStart);
      let endDate = helper.formatDate(this.$refs['dateRangeFilter'].filterDateEnd);
      printCSV('#jt-table', `Report Company Customer Status ${startDate} - ${endDate}`);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportCustomerCompany.vue